import {useEffect, useMemo, useRef} from 'react'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {getMostRecentNonActiveGoal} from 'hec/builder/helpers/learningCenterHelpers'
import useLearningCenter from '~/app/hooks/use-learning-center'
import useTpaMarketingConsent from '~/app/hooks/use-tpa-marketing-consent'
import {identifyUser} from './eventHandlers'
import {sessionKeys} from './constants'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

export const IdentifySegmentUser = () => {
    const {data: customer} = useCurrentCustomer()
    const {getActiveGoal, learningCenterData} = useLearningCenter()
    const {canTrackMarketingEvents} = useTpaMarketingConsent()
    const activeGoal = getActiveGoal()
    const {site} = useMultiSite()
    const isRegisteredUserWithEmail = customer.isRegistered && customer?.email
    const isHSA = site.id === 'HSASTORE'

    const previousGoal = useMemo(
        () => getMostRecentNonActiveGoal(learningCenterData) || '',
        [learningCenterData]
    )

    const lastIdentifiedTraits = useRef(
        typeof window !== 'undefined' ? sessionStorage.getItem(sessionKeys.identified) : null
    )

    useEffect(() => {
        if (!isRegisteredUserWithEmail || !canTrackMarketingEvents()) return

        const traits = {
            email: customer.email
        }
        if (isHSA) {
            if (activeGoal?.id) {
                traits.currentHSAPersona = activeGoal.id
            }
            if (previousGoal) {
                traits.previousHSAPersona = previousGoal
            }
        }

        const traitsKey = JSON.stringify(traits)
        if (lastIdentifiedTraits.current === traitsKey) return

        identifyUser(customer.email, traits)
        lastIdentifiedTraits.current = traitsKey
        sessionStorage.setItem(sessionKeys.identified, traitsKey)
    }, [
        customer,
        activeGoal,
        previousGoal,
        isHSA,
        isRegisteredUserWithEmail,
        canTrackMarketingEvents
    ])

    // Reset when the user logs out
    useEffect(() => {
        if (!isRegisteredUserWithEmail) {
            lastIdentifiedTraits.current = null
            sessionStorage.removeItem(sessionKeys.identified)
        }
    }, [isRegisteredUserWithEmail])

    return null
}
